// These are the last sub "folder" of the checkout URL
export const SHIPPING_ADDRESS = 'shipping-address';
export const ACCOUNT_DETAILS = 'account-details';
export const PAYMENT = 'payment';
export const SUCCESS = 'success';
export const CREATE_ACCOUNT = 'create-account';
